import ArrowThickLeftIcon from './arrow-thick-left.svg';

const ArrowThickLeft = (props) => (
  <ArrowThickLeftIcon {...props} focusable="false" style={{ transform: 'rotate(180deg)' }} />
);

export default ArrowThickLeft;
